module.exports = "data:image/png;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJtZWRpYS9hcHBsZV9zYWZhcmkucG5nIjs="